import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Constant } from './modules/shared/constants';
import { Home } from './report/home/home';
import { SupervisionReport } from './supervision-report/supervision-report';
import { RoleGuard } from './modules/shared/role.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { USERROLE } from './modules/shared/models';
import { AdminComponent } from './admin/admin.component';

export function msalHashCallbackMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (!segments.length) {
    return null;
  }

  const raw = segments.map(s => s.path).join('/');
  const decoded = decodeURIComponent(raw);
  const isMsalCallback =
    decoded.startsWith('code=') ||
    decoded.startsWith('error=') ||
    decoded.includes('&client_info=') ||
    decoded.includes('&session_state=');

  return isMsalCallback ? { consumed: segments } : null;
}

const routes: Routes = [
  {
    matcher: msalHashCallbackMatcher,
    redirectTo: 'home'
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'home',
    component: Home,
    canActivate: [RoleGuard]
  },

    {
    path: 'report',
    component: SupervisionReport,
    canActivate: [MsalGuard, RoleGuard]
  },

  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: [USERROLE.SUPERVISION] }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
